import * as types from './types'

import { auth } from './actions'

const authReducer = (state = {
  isAuthenticated: auth.isAuthenticated(),
  profile: undefined,
  isFetching: false,
  error: null
}, action) => {
  switch (action.type) {
    case types.LOGIN_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      }
    case types.GET_PROFILE:
      return {
        ...state,
        isFetching: false,
        profile: action.payload.profile,
        error: null
      }
    case types.LOGIN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: true,
        returnUrl: action.payload.returnUrl,
        profile: action.payload.profile
      }
    case types.LOGIN_ERROR:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
        profile: undefined,
        error: action.payload.err
      }
    case types.LOGOUT_SUCCESS:
      return {
        ...state,
        isAuthenticated: false,
        profile: undefined
      }
    default:
      return state
  }
}

export default authReducer
